import React from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import { ArrowLink, BoxButton, TextButton } from '@riac/design-system';

import {
  ActiveAuctionAside, ActiveAuctionContainer, ActiveAuctionInfo, ActiveAuctionButtons,
} from 'src/components/ActiveAuction/ActiveAuction.style';
import { FaPhone } from 'react-icons/fa';
import { AuctionDate } from '../AuctionDate/AuctionDate';
dayjs.extend(advancedFormat);

type ActiveAuctionProps = React.PropsWithChildren<{
  auction: {
    active: boolean,
    AuctionID: string | number,
    AuctionTypeID: string | number,
    StartDate: string,
    StartTime: string,
    EndDate: string,
    Title: string,
    PhoneAvailability: boolean,
  },
}>;

export const ActiveAuction = ({ auction } : ActiveAuctionProps ): JSX.Element => {
  if(auction.StartDate && auction.StartTime) {
    const start = dayjs(auction.StartDate + ' ' + auction.StartTime);
    const now = dayjs();
    if(auction.AuctionTypeID === TIMED_AUCTION_TYPE_ID && now.isBefore(start)) {
      return (<></>);
    }
  }
  return (
    <ActiveAuctionAside>
      <ActiveAuctionContainer>
        <ActiveAuctionInfo>
          <strong>{auction.Title}</strong>
          <AuctionDate auction = {auction} timeSpacer = 'at' omitTime={auction.AuctionTypeID === TIMED_AUCTION_TYPE_ID}/>
          {auction.PhoneAvailability ? <TextButton to='/phone-bidding/'>Phones are Open <FaPhone/></TextButton> : ''}
        </ActiveAuctionInfo>
        <ActiveAuctionButtons>
          {auction.active && <BoxButton to='/live' target='' rel=''>Bid Live</BoxButton>}
          <ArrowLink to={`/catalog/${auction.AuctionID}`}>View Catalog</ArrowLink>
        </ActiveAuctionButtons>
      </ActiveAuctionContainer>
    </ActiveAuctionAside>
  );
};
